<script>
	import Button from "../../components/Button.svelte";
	import {openAuth} from "../../api/user";
</script>

<section class="section cover">
	<div class="lines-bg">
		<div class="container">
			<h2 class="h1 section__title tac b">All-in-One Trucking Dispatch Software</h2>
			<p class="h5 section__subtitle tac">Now truck dispatchers can optimize their workflow with Loder’s all-in-one fleet dispatch management software.</p>
			<Button label='Start trial' width='150px' type='filled section__button' handleClick={() => openAuth()}/>
			<img src="./assets/gifs/cover-gif.gif" alt="Gif Animation" class="cover__gif">
			<div class="cover__row">
				<p class="h6 cover__text">The Loder platform holds driver contact information, cargo loads, broker contact information and more, making it easier than ever to link shipments and drivers quickly.</p>
				<p class="h6 cover__text">Dispatchers can search and filter for available drivers, automatically monitor driver events like pick-ups and drop-offs, and directly communicate with brokers via email.</p>
			</div>
		</div>
	</div>
</section>

<style>
	.cover {
		background: var(--system-background-primary);
	}
	.cover__gif {
		width: 100%;
		margin: 70px 0;
	}
	.cover__row {
		display: flex;
		max-width: 1152px;
		width: 100%;
		margin: 0 auto;
		gap: 50px;
		justify-content: space-between;
	}
	.cover__text {
		display: flex;
		gap: 32px;
		position: relative;
		color: var(--text-color-secondary);
		margin: 0;
	}
	.cover__text::before {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		background: var(--system-background-tertiary);
		border-radius: 50%;
	}
	.cover__text::after {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		border: 5px solid var(--color-primary-500);
		border-radius: 50%;
		position: absolute;
		left: 12px;
		box-sizing: border-box;
	}
	.section {
		padding: 150px 0;
	}
	.section__title {
		margin: 0;
	}
	.section__subtitle {
		max-width: 540px;
		width: 100%;
		margin: 35px auto;
		color: var(--text-color-tertiary);
	}
	:global(.section__button) {
		display: block;
		margin: 0 auto;
	}
	.tac {
		text-align: center;
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
	}
	.lines-bg {
		background: url('../assets/img/cover-bg.png') no-repeat;
	}

	@media(max-width: 1200px) {
		.container {
			max-width: 940px;
		}
		.section {
			padding: 120px 0;
		}
		.section__title {
			font-size: 32px;
			line-height: 40px;
		}
		.section__subtitle {
			margin: 25px auto;
		}
		.cover__gif {
			margin: 54px 0;
		}
		.cover__text {
			font-size: 14px;
			line-height: 17px;
		}
	}
	@media(max-width: 960px) {
		.lines-bg {
			background-position: 0 100px;
		}
		.container {
			max-width: 620px;
		}
		.cover__row {
			gap: 32px;
		}
		.cover__text {
			gap: 22px;
		}
		.cover__gif {
			margin: 60px 0;
		}
	}
	@media(max-width: 640px) {
		.container {
			max-width: 460px;
		}
		.section__title {
			font-size: 24px;
			line-height: 30px;
		}
		.section__subtitle {
			margin: 20px auto;
			font-size: 14px;
			line-height: 17px;
		}
		.cover__gif {
			margin: 50px 0;
		}
		.cover__row {
			flex-direction: column;
			gap: 40px;
		}
		.cover__text {
			gap: 46px;
			font-size: 12px;
			line-height: 14px;
		}
		.section {
			padding: 100px 0;
		}
	}
	@media(max-width: 480px) {
		.section__title {
			max-width: 200px;
			margin: 0 auto;
		}
		.lines-bg {
			background: none;
		}
		.container {
			max-width: 300px;
		}
		.cover__gif {
			margin: 40px 0;
			width: 582px;
			height: 342px;
		}
		.cover__row {
			gap: 20px;
		}
		.section {
			padding: 70px 0;
		}
	}
</style>